export const getImageAsBase64 = async (imgPath) => {
  try {
    const response = await fetch(imgPath);
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('Error converting image to Base64:', error);
    return imgPath;
  }
};

export const handleDefaultImages = async (
  isNewCard,
  formCard,
  promoProxImg,
  promoProxImgMobile,
  urlImg,
  urlImgMobile,
  estabProxImg,
  estabProxImgMobile,
  estabSelectImg,
  estabSelectImgMobile,
  cashBackImg,
  cashBackImgMobile,
  promoSelectImg,
  promoSelectImgMobile,
  listType,
  setCardDefault,
  setCardDefaultDetails,
  setFormCard
) => {
  if (!isNewCard || formCard.thumbDesktop) return;

  let defaultDesktopImg = promoProxImg;
  let defaultDetailsImg = promoProxImgMobile;

  if (formCard.cardType === 'card_url') {
    defaultDesktopImg = urlImg;
    defaultDetailsImg = urlImgMobile;
  } else if (formCard.cardType === 'card_list') {
    if (formCard.action === 'establishment_list') {
      defaultDesktopImg = listType === 'proximos_mim' ? estabProxImg : estabSelectImg;
      defaultDetailsImg = listType === 'proximos_mim' ? estabProxImgMobile : estabSelectImgMobile;
    } else if (formCard.action === 'promotion_list' || formCard.action === 'product_list') {
      if (listType === 'pointsback') {
        defaultDesktopImg = cashBackImg;
        defaultDetailsImg = cashBackImgMobile;
      } else {
        defaultDesktopImg = listType === 'proximos_mim' ? promoProxImg : promoSelectImg;
        defaultDetailsImg = listType === 'proximos_mim' ? promoProxImgMobile : promoSelectImgMobile;
      }
    }
  }

  const desktopBase64 = await getImageAsBase64(defaultDesktopImg);
  const detailsBase64 = await getImageAsBase64(defaultDetailsImg);

  setCardDefault(desktopBase64);
  setCardDefaultDetails(detailsBase64);

  setFormCard((prev) => ({
    ...prev,
    thumbDesktop: '',
    thumbMobile: '',
    mobileDetails: '',
  }));
};
